




























































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import BlockView from '../components/blockView.vue';
import { categoryThreeId,findBrandsList } from "@/utils/api";

@Component({
  components:{
    BlockView
  }
})
export default class BasicsInfo extends Vue {
  @Prop(Object) goodsInfo!: object;
  @Watch('goodsInfo',{immediate:true,deep:true})
  goodsInfoChange(newVal: object){
    if(newVal['categoryId'].length > 0 && newVal['selectedName'] !== this.selectedName){
      this.selectedName=newVal['selectedName'];
      this.basecsInfo=newVal;
      this.categoryParams=newVal['categoryParams'];
      this.categoryAttr(newVal['categoryId'][2]);
    }
  }

  selectedName: string = '';//名称
  loading: boolean = false;//加载框
  isOpen: boolean = false;//类目属性默认展开
  isFold: boolean = false;//折叠展示
  basecsInfo: object = {};//数据
  categoryData: Array<object> = [];//类目属性数据
  brandsList: Array<object> = [];//品牌列表
  categoryParams: Array<object> = [];//选中类目属性数据
  rules: object = {brandId: [{ required: true, message: '请选择品牌', trigger: 'blur' }]}

  mounted () {
    this.findBrandsList();
  }
  /* 类目属性展开收起 */
  develop(){
    this.isOpen=!this.isOpen;
  }
  /* 基础信息展示折叠 */
  foldUp(){
    this.isFold=!this.isFold;
  }
  /* 修改类目 */
  modifyCategory(){
    let that=this;
    this.$confirm('未保存的内容将丢失，确认离开吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      let data={
        categoryId:that.basecsInfo['categoryId'],
        categoryName:that.basecsInfo['categoryName'],
        selectedName:that.basecsInfo['selectedName'],
        isShowCategory:true
      }
      this.$emit('modifyCategory', data);
    }).catch(() => {});
  }

  /* 获取类目属性 */
  categoryAttr(catThreeId){
    this.loading=true;
    categoryThreeId({catThreeId}).then((data:any)=>{
      let categoryParams=this.categoryParams;
      if(categoryParams.length>0){
        data.forEach(item=>{
          let valueName='';
          categoryParams.forEach(el=>{
            if(item['itemId']==el['itemId']){
              valueName=`${el['valueId']}|${el['valueName']}`;
            }
          })
          item['valueName']=valueName;
        })
        this.categoryData=data;
      }else{
        data.forEach(item=>{
          item['valueName']='';
        })
        this.categoryData=data;
      }
      this.loading=false;
    })
  }
  /* 获取品牌 */
  findBrandsList(){
    findBrandsList({}).then((data:any)=>{
      this.brandsList=data;
    })
  }
  /* 获取选中的值 */
  handleChange(value){
    console.log(value);
    let categoryData=this.categoryData;
    let array=[];
    categoryData.forEach(item=>{
      if(item['valueName']!=''){
        let group=item['valueName'].split('|');
        let data={
          valueId:group[0],
          valueName:group[1],
          itemId:item['itemId'],
          itemName:item['itemName']
        }
        array.push(data);
      }
    })
    this.$emit('categoryParams', array);
  }
  /* 输入spu名称改变没有规格的sku名称 */
  turnSkuName(val){
    let basecsInfo=this.basecsInfo;
    if(basecsInfo['commoditySkuInfo'].length==1 && basecsInfo['commoditySkuInfo'][0]['skuSpecifications'].length==0){
      basecsInfo['commoditySkuInfo'][0]['skuName']=val;
    }
  }
}
